import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Dogs } from '../Assets/comendus.svg';
import { UserContext } from '../UserContext';
import Relogio from './Util/Relogio';
import ClimaTempo from './Util/Climatempo';
import Sobre from './Util/Sobre';
import styles from './Header.module.css';
import moment from 'moment';
import localization from 'moment/locale/pt';

const Header = () => {
  //let dataAtual = 'Porto Alegre, ' + moment().locale("pt", localization).format('dddd LL');

// garanta o locale correto
const m = moment().locale('pt-br'); // ou 'pt'

const weekday = m.format('dddd').toLowerCase();           // quinta-feira
const day     = m.format('D');                            // 18
const month   = m.format('MMMM');                         // setembro (vem minúsculo no pt)
const monthCap = month.charAt(0).toUpperCase() + month.slice(1); // Setembro
const year    = m.format('YYYY');                         // 2025

const dataAtual = `Porto Alegre, ${weekday} ${day} de ${monthCap} de ${year}`;

  React.useEffect(() => {

    //dataAtual = moment().format('HH:mm:ss');

  }, []);


  return (
    <header id="header">
      <div className={styles.divx}>
      <h1><a href="/" className={styles.logo}>entradafranca.com</a></h1>
      <p className="tituloaproveite">aproveite&nbsp;<span>&nbsp;o&nbsp;seu&nbsp;melhor&nbsp;</span>&nbsp;tempo&nbsp;&nbsp;livre</p>
      </div>
      <nav style={{ height : '100%' }}>
        <ul style={{ height : '100%', marginTop : '-10px', zIndex : '10'}}>
          <li style={{ height : '100%'}}><a style={{ height : '100%'}} className={styles.menu}><Relogio/><ClimaTempo/><Sobre/></a></li>
        </ul>
      </nav>
      <p className={styles.data} style={{ zIndex : '0'}}>{ dataAtual }</p>
      </header>
  );
};

export default Header;
